import { request } from '@/api/client';
import type { User } from '@/types/user';

export function fetchUsers(search?: string): Promise<User[]> {
  return request<User[]>('/users', { params: { search } });
}